import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import { useEffect, useState } from "react";
import Add from "../table/Add";
import { method } from "lodash";
import { data, useNavigate } from "react-router-dom";






const AddSchemeSummary = () =>{

    const [schemeVillageData, setSchemeVillageData] = useState<any>([]);
     const navigate = useNavigate();
    const fetchSchemeVillage = async ()=>{
        try{
        const response = await ApiService.axiosApi(`/schemevillage`,{
            method: 'GET',
            params:{
                pageNumber :0,
                pageSize:0
           }
        });
          if(response.success){
            setSchemeVillageData(response.data.data);
          }
        }catch(error:any){
            toast.error(error.message || "Failed to fetch Scheme Village");
        }
    } 
    useEffect(()=>{
           fetchSchemeVillage();
    },[])

    const handleSubmit = async(data:any) =>{
          try{
            const response = await ApiService.axiosApi(`/allschemesummary`,{
                 method:'POST',
                 data:{
                     DistributionVolume:data.DistributionVolume,
                     SchemeVillageId:data.SchemeVillageId

                 }
            })    
            if(response.success){
                 toast.success('Distribution Added Successfully');
                 navigate(-1)
            }else{
                 toast.error('Unable to Add Distribution')
            }
          }catch(e){
             console.log(e);
          }
          
    }

    return(
         <>
            <Add 
            title={'Add Scheme Summary'}
            parentTitle={'SchemeSummary'}
            onSubmit={handleSubmit}
            fields={[
                {
                    name: "DistributionVolume",
                    label: "Distribution",
                    type: "text",
                    validation: { required: "Distribution is required" }
                },
                
               
                {
                    name: "Scheme_Village",
                    label: "Scheme Village",
                    isDropdown:true,
                    dropdownData:schemeVillageData,
                    dropdownLabel:"scheme_Village",
                    idFieldName:"SchemeVillageId"
                 },
                 
               
            ]} 
        />
         </>
    )
}

export default AddSchemeSummary;